import React from 'react';
import { Link } from 'react-router-dom';

export const RefundsPage = () => {
  return (
    <div className="min-h-screen bg-[#FAF8F5]" data-testid="refunds-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <h1 className="font-['Bodoni_Moda'] text-4xl font-bold text-[#2A2A2A] mb-8">
          Refund Policy
        </h1>

        <div className="prose prose-lg max-w-none text-[#444]">
          <p className="text-sm text-[#666] mb-8">Last updated: January 2026</p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Our Commitment
          </h2>
          <p>
            We want you to love your Country Bo blends. If you're not completely satisfied with your purchase, we're here to help.
          </p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Eligibility
          </h2>
          <p>
            To be eligible for a refund or replacement, you must contact us within 30 days of receiving your order. Please include your order number and a description of the issue.
          </p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Damaged or Defective Products
          </h2>
          <p>
            If your order arrives damaged or you receive a defective product, we will replace it at no cost to you. Please include photos of the damage when contacting us.
          </p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Refund Process
          </h2>
          <p>
            Once we receive and review your request, we'll notify you of the approval or rejection of your refund. If approved, your refund will be processed to your original payment method within 5-10 business days.
          </p>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Non-Refundable Items
          </h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Products that have been opened and used (unless defective)</li>
            <li>Gift cards</li>
            <li>Products purchased more than 30 days ago</li>
          </ul>

          <h2 className="font-['Bodoni_Moda'] text-2xl font-bold text-[#2A2A2A] mt-8 mb-4">
            Contact Us
          </h2>
          <p>
            For refund requests or questions, please{' '}
            <Link to="/contact" className="text-[#D4540A] hover:underline">
              contact us
            </Link>{' '}
            with your order details.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RefundsPage;
